export const DataFaqOne = {
  title:
    "3 raisons pour lesquelles vous avez pris la meilleure décision pour votre entreprise en nous choisissant.",
  subTitle: "Pourquoi Nous ?",
  img: "assets/images/faq/faq-1.png",
  items: [
    {
      id: 0,
      question: "Une Equipe Hautement Qualifiée",
      answer:
        "Notre équipe est constituée d’Ingénieurs et de Techniciens expérimentés ayant en moyenne dix (10) années d’expérience dans les différents domaines d’ingénierie. Ils ont fait leurs preuves dans de multinationales qui ont des standards élevés.",
    },
    {
      id: 1,
      question: "Normes & Réglementation",
      answer:
        "Nous travaillons autour des valeurs et stratégies qui permettent à nos Ingénieurs et Techniciens de réussir n’importe quel projet. Il s’agit : Qualité, juste prix et respect des délais ; SETELEC SAS s’est inscrite dès sa création dans une démarche qualité conformément aux normes ISO 9001, 14001 et 45001 qui sont nos référentiels quotidiens. Cette démarche qualité permet à nos équipes de travailler selon les standards internationaux de qualité, de sécurité et d’environnement ;  Chez nous, le client est ROI, nous visons toujours sa satisfaction. ",
    },
    {
      id: 2,
      question: "Environnement",
      answer:
        "SETELEC assure des relations de bon partenariat avec les entreprises pour lesquelles elle travaille, dans le respect des lois et de l'éthique professionnelle.",
    },
  ],
  btnInfo: "Vous avez encore des questions?",
  btnLink: "/Contact",
};
